<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="queueInfo" (ngSubmit)="handleSave()">
    <div class="basic-edit-container" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="name property">
          <div class="mat-body-1 property-header">Queue name</div>
          <mat-form-field appearance="outline" class="text-field">
            <input
              matInput
              formControlName="queueName"
              autocomplete="off"
              [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_NAME"
            />
            <mat-error>{{ getGenericError(queueInfo.controls.queueName, "Queue name") }}</mat-error>
          </mat-form-field>
        </section>
        <section class="sip-address property with-mat-form-field">
          <div class="mat-body-1 property-header">Queue SIP address</div>
          <onsip-sip-address-field formControlName="queueSipAddress"> </onsip-sip-address-field>
        </section>
        <section class="extensions property">
          <div class="mat-body-1 property-header">Queue extensions</div>
          <onsip-extensions-list
            #queueExtensionsList
            formControlName="queueExtensions"
            [currentId]="queueAddressId"
          >
          </onsip-extensions-list>
        </section>
      </div>
      <div class="second-column" onsip-grid-placement-shelf>
        <div class="login-row row-1">
          <section class="login-sip-address property with-mat-form-field">
            <div class="mat-body-1 property-header">Login SIP address</div>
            <onsip-sip-address-field formControlName="loginSipAddress"> </onsip-sip-address-field>
          </section>
        </div>
        <div class="login-pw-row row-2">
          <section class="login-pw property">
            <div class="mat-body-1 property-header">Login password</div>
            <mat-form-field appearance="outline" class="text-field password-field">
              <input
                matInput
                formControlName="loginPassword"
                autocomplete="off"
                [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_LOGIN_PASS"
              />
              <mat-error>{{
                getGenericRequiredError(queueInfo.controls.loginPassword, "Login password")
              }}</mat-error>
            </mat-form-field>
          </section>
        </div>
        <div class="login-row row-3">
          <section class="login-extensions property">
            <div class="mat-body-1 property-header">Login extensions</div>
            <onsip-extensions-list
              #loginExtensionsList
              formControlName="loginExtensions"
              [currentId]="loginAddressId"
            >
            </onsip-extensions-list>
          </section>
        </div>
      </div>
      <div class="third-column">
        <section class="max-callers property">
          <div class="mat-body-1 property-header">Max callers in queue</div>
          <mat-form-field
            appearance="outline"
            class="text-field max-field"
            onsip-form-field-infix-auto
          >
            <input matInput required formControlName="maxCallers" autocomplete="off" />
            <mat-error>{{
              getGenericRequiredError(queueInfo.controls.maxCallers, "Max callers in queue")
            }}</mat-error>
          </mat-form-field>
        </section>
        <section class="max-agents property">
          <div class="mat-body-1 property-header">Max agents</div>
          <div class="agent-field-price-container">
            <mat-form-field
              appearance="outline"
              class="text-field max-field max-agents-field"
              onsip-form-field-infix-auto
            >
              <input matInput required formControlName="maxAgents" autocomplete="off" />
              <mat-error>{{
                getGenericRequiredError(queueInfo.controls.maxAgents, "Max agents")
              }}</mat-error>
            </mat-form-field>
            <span class="mat-body-1 agent-price">{{ agentPricingText }}</span>
          </div>
        </section>
      </div>
      <div class="page-view-controls">
        <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
        <button
          type="submit"
          mat-flat-button
          color="primary"
          [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_EDIT_SHELVE_EDIT_BUTTON"
        >
          Save changes
        </button>
      </div>
    </div>
  </form>
</onsip-loading-container>
